var jQuery = require('jquery');
require('jquery-ui/ui/widgets/dialog');

export function confirm(deleteCallback, cancelCallback, title, message)
{  
    jQuery( "#dialog-confirm" ).dialog({
        resizable: false,
        height: "auto",
        width: 600,
        modal: false,
        buttons: {
            Nevermind: {
                click: function() {
                    jQuery(this).dialog("close");
                    cancelCallback();
                },
                text: 'Nevermind',
                'class': 'btn background-gray-400',
            },
            Delete: {
                click: function() {
                    jQuery(this).dialog("close");
                    deleteCallback();
                },
                text: 'Yes, confirm',
                'class': 'btn background-red text-white',
            },
        },
        create: function() {

            if( !title )
                title = 'Are you sure?';

            jQuery(this).closest(".ui-dialog").find(".dialog-title").text(title);

            if( !message )
                message = '';

            jQuery(this).closest(".ui-dialog").find(".dialog-message").text(message);
        }
    });
};